<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Orçamento</th>
        <th scope="col" class="border-0">Empresa</th>
        <th scope="col" class="border-0 text-center">Qtd. Amostragens</th>
        <th scope="col" class="border-0 text-center">Criado em</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in quotations" :key="index">
        <td>
          {{ row.reference_no }}
        </td>
        <td class="link">
          <d-link :to="{ name: 'admin-customer-edit', params: { customerId: row.customer.id }}">{{ row.customer.name }}</d-link>
        </td>
        <td class="text-center">
          {{ row.sample_count}}
        </td>
        <td class="text-center">
          {{ row.f_created_at }}
        </td>
        <td class="text-center">
          <d-button-group class="buttons">
            <d-link v-if="hasQuotationsModule" class="btn btn-primary" :to="{ name: 'admin-quotation-edit', params: { quotationId: row.id } }">
              Ver orçamento
            </d-link>
            <d-link class="btn btn-success" :to="{ name: 'admin-sample-list', params: { page: 1, quotationId: row.id } }">Ver amostragens</d-link>
          </d-button-group>
        </td>
      </tr>
      <tr v-if="quotations.length === 0">
        <td colspan="5" class="no-content">Ainda não tem nenhum orçamento aprovado com amostragens.</td>
      </tr>
    </tbody>
    <div>
  </div>
  </table>
</template>

<script>
export default {
  name: 'sample-by-quotation-table',
  props: {
    quotations: {
      type: Array,
    },
  },
  computed: {
    hasQuotationsModule() {
      const { modules } = this.$store.state.user.user;
      return modules.some(module => module.slug === 'quotations') || false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-success {
  &:disabled {
    border-color: #ababab;
    background: #b8b8b8;
  }
}
</style>
